import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Consent } from '@app-models/site';
import { Moment } from 'moment';
import * as moment from 'moment';

@Component({
  selector: 'app-consent-dialog',
  templateUrl: './consent-dialog.component.html',
  styleUrls: ['./consent-dialog.component.scss']
})
export class ConsentDialogComponent implements OnInit {

  consent: Consent;
  ​status: string;
  statusClass: string;
  readOnly: boolean;

  constructor(
    public dialogRef: MatDialogRef<ConsentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Consent
  ) {
    this.readOnly = true;
    this.consent = Object.assign({}, data);
    if (this.consent.activeDatetime && this.consent.expiredDatetime) {
      this.status = 'ฉบับยกเลิก';
      this.statusClass = 'expired';
    } else if (this.consent.activeDatetime && !this.consent.expiredDatetime) {
      this.status = 'ฉบับปัจจุบัน';
      this.statusClass = 'current';
    } else {
      this.status = 'ฉบับร่าง';
      this.statusClass = 'draft';
      this.readOnly = false;
    }
  }

  formatDate(date: Moment, defaultVal: string): string {
    if (date) {
      return date.locale('th').format('D MMMM') + ' ' + (date.year() + 543);
    } else {
      return defaultVal;
    }
  }

  ngOnInit(): void {
  }

  preview() {
    this.readOnly = true;
  }

  backFromPreview() {
    this.readOnly = false;
  }

  validDocData(): boolean {
    return this.consent.docData && (this.consent.docData.length > 140);
  }

  publish() {
    this.consent.activeDatetime = moment();
    this.dialogRef.close(this.consent);
  }

}
